<div *ngIf="superTaskDetails?.superTaskId" class="task-header">
  <div class="d-flex border-bottom">
    <div class="">
      <img height="50" width="50" [src]="avatarSrc ? avatarSrc : '../../../../assets/profile.png' "
        alt="profile picture">
    </div>
    <div class="flex-grow-1 px-3 pb-3">
      <div class="row d-flex bene-task">
        <span class="stand-out">Task ID - {{superTaskDetails?.superTaskId}} </span>
        <!-- <span *ngIf="!isImmigrationVisiable"> -->
        <span >
          <span class="pl-3 d-flex" *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
            <p-inputSwitch name="isBeneficiaryVisible" [(ngModel)]="isBeneficiaryVisible" class="pr-3" 
            (click)="getTaskBeneficiarySummery()"></p-inputSwitch> <i class="pi pi-info-circle
            " pTooltip="Slide this to ON position, to make Tasks and Timelines visible to beneficiary. Slide to OFF position to hide Tasks and Timelines." style="color: #01a0da;"></i>
          </span>     </span>
      
      </div>
      <div class="task-header-summary">
        <div class="border-right pr-2 border-dark float-left">
          <label class="float-left mb-0">{{ (SubTaskTypeList.includes('I130') || ['K1','K3'].includes(superTaskDetails.visaType?.code) || ['F1','F2A','F2B','F3','F4','IR1','IR2','IR5'].includes(superTaskDetails.immigrationClassification?.code)) ? 'Sponsor : ' : isDependentVisa  ?  'Primary Visa Holder : ' :'Beneficiary : '
            }}{{ SubTaskTypeList.includes('I130') ? superTaskDetails?.sponsorFirstName + ' ' +
            superTaskDetails?.sponsorLastName : superTaskDetails?.beneficiaryFirstName + ' ' +
            superTaskDetails?.beneficiaryLastName}} </label>
          <div class="d-inline-block pl-1 float-left">
            <a class="align-middle text-primary float-left" (click)="viewbeneficiaries()"
              *ngIf="userType != 'Beneficiary' && !!beneficiaryId">
              <mat-icon matTooltip="View Beneficiary" class="material-icons float-left">person</mat-icon>
            </a>
          </div>
        </div>
        <div class="border-right px-2 border-dark float-left" *ngIf="!SubTaskTypeList.includes('I130') && !(['F1','F2A','F2B','F3','F4','IR1','IR2','IR5'].includes(superTaskDetails.immigrationClassification?.code))">
          <label class="float-left mb-0">Company : {{superTaskDetails?.companyName}}</label>
          <div class="d-inline-block pl-1 float-left">
            <a class="align-middle text-primary float-left" (click)="viewcompany()"
              *ngIf="userType != 'Beneficiary' && !!beneCompany">
              <mat-icon matTooltip="View Company" disabled="isViewcompany" class="material-icons float-left">
                corporate_fare
              </mat-icon>
            </a>
          </div>
        </div>
        <ng-template ngFor let-summaryDetail [ngForOf]="summaryDetailsList" let-i="index">
          <label class="px-2 float-left mb-0"
            [ngClass]="{'border-right border-dark': i < (summaryDetailsList.length - 1) }">{{ summaryDetail?.name }} :
            <span>{{ summaryDetail?.value }}</span></label>
        </ng-template>
        <div class="border-left px-2 border-dark float-left" *ngIf="(isDependentVisa || ['F1','F2A','F2B','F3','F4','IR1','IR2','IR5','ONLINEIMMVISAREG'].includes(superTaskDetails.immigrationClassification?.code)) && this.applicantNameList.length > 0">
          <label class="float-left mb-0"> Applicants : <ng-template ngFor let-applicant [ngForOf]="applicantNameList" let-i="index" let-isLast="last"><span class="px-1">{{applicant?.firstName}} {{applicant?.lastName}}</span><span *ngIf="!isLast">,</span></ng-template> </label>
          <div class="d-inline-block pl-1 float-left">
          
          </div>
        </div>
      </div>
    </div>
  </div>

</div>